<template>
  <v-card class="mt-4">
    <v-card-item>
      <v-card-title>
        Company attachments:
      </v-card-title>
      <v-card-text class="overflow-y-auto pl-0">
          <v-skeleton-loader
              class="pa-4 mb-2 pl-0"
              type="chip@7"
          />
      </v-card-text>
      <v-card-title>
        {{ isClientView ? 'Own attachments:' : 'Client attachments:' }}
      </v-card-title>

      <v-card-text class="overflow-y-auto pl-0 pb-0">
          <v-skeleton-loader
              class="pa-4 mb-2 pl-0"
              type="chip@4"
          />
      </v-card-text>
      <v-card-text
          class="pb-0"
      >
        <v-skeleton-loader
          type="heading"
        />
      </v-card-text>
    </v-card-item>
  </v-card>
</template>

<script>

export default {
  name: "CarRequestAttachmentCardSkeleton",
  props: {
    isClientView: Boolean
  }
}
</script>

<style scoped>

</style>